<template>
  <div class="d-flex flex-column align-start justify-start">
    <div class="article-card-container-loader">
      <DpplSkeletonLoader class="w-100">
        <div class="article-image-loader-container" />
      </DpplSkeletonLoader>
      <div class="article-body-loader">
        <v-skeleton-loader
          type="text"
          min-width="100%"
          height="16px"
        />
        <v-skeleton-loader
          type="text"
          min-width="75%"
          height="16px"
          class="mb-3"
        />
        <v-skeleton-loader
          type="text"
          min-width="30%"
          height="16px"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';
</script>

<style scoped lang="less">
:deep(.v-skeleton-loader__text) {
  margin: 0 !important;
}

.article-card-container-loader {
  width: 214px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background: @white;
  border-radius: 8px;
  border: 1px solid @stroke-default;
}

.article-image-loader-container {
  width: 100%;
  height: 134px;
  background: fade(@grey-900, 15%);
  border-radius: 8px 8px 0 0;
}

.article-body-loader {
  width: 100%;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
</style>
